import PropTypes from 'prop-types';
import React from 'react';
import { useDispatch } from 'react-redux';
import { Router } from 'react-router-dom';
import { locationChanged } from '../../routing';

export default function RouterProvider({ children, history }) {
  const dispatch = useDispatch();

  React.useEffect(() => history.listen((location) => dispatch(locationChanged(location))), [dispatch, history]);

  return <Router history={history}>{children}</Router>;
}

RouterProvider.propTypes = {
  children: PropTypes.node.isRequired,
  history: PropTypes.object.isRequired,
};
